/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";
modulum("ApplicationEnding", function (context, cls) {
  /**
   * application ending
   * @class ApplicationEnding
   * @memberOf classes
   */
  class ApplicationEnding /** @lends classes.ApplicationEnding.prototype */ {
    constructor(isNormal, flag) {
      this.normal = isNormal;
      this.flag = flag;
      this.message = null;
    }

    static ok() {
      return new ApplicationEnding(true);
    }

    static notok(message) {
      const result = new ApplicationEnding(false, "notok");
      result.message = cls.StringHelper.escapeHTML(message);
      gbc.LogService.networkProtocol.error(message);
      return result;
    }

    static notFound() {
      return new ApplicationEnding(false, "notFound");
    }

    static forbidden() {
      return new ApplicationEnding(false, "forbidden");
    }

    static uaProxy(message) {
      const result = new ApplicationEnding(false, "uaProxy");
      result.message = message;
      return result;
    }

    static autoLogout(message) {
      const result = new ApplicationEnding(false, "autoLogout");
      result.message = message;
      return result;
    }

    static logPlayer() {
      return new ApplicationEnding(true, "hidden");
    }
  }
  cls.ApplicationEnding = ApplicationEnding;
});
